module.exports = __webpack_public_path__ + "img/ic-home-cunkuan.b71e.7c421282.png";